import { inject } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { ResolveFn } from '@angular/router'

import { Observable, map } from 'rxjs'

import { ApplicationPermissionsStore } from '@flowx/designer/modules/projects/store/application-permissions.store'
import { DetailedPermissions } from '@flowx/designer/modules/workspaces/shared/workspace.utils'

export const ApplicationProcessesPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.permissions).pipe(
    map((permissions) => ({
      canEdit: !!permissions.process_edit,
      canCreate: !!permissions.process_create,
      canDelete: !!permissions.process_delete,
      canImport: !!permissions.process_edit,
    }))
  )
}

export const ApplicationReusableFunctionsPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.reusableFunctionsAccessRights)
}

export const ApplicationReusableTemplatesPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.reusableTemplatesAccessRights)
}

export const ApplicationUiFlowsPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.uiFlowsAccessRights)
}

export const ApplicationCustomComponentsPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  return toObservable(applicationPermissionsStore.permissions).pipe(
    map((permissions) => ({
      canRead: !!permissions.custom_component_read,
      canEdit: !!permissions.custom_component_edit,
      canCreate: !!permissions.custom_component_create,
      canDelete: !!permissions.custom_component_delete,
      canImport: !!permissions.custom_component_edit,
    }))
  )
}

export const ApplicationMlModelsPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  return toObservable(applicationPermissionsStore.permissions).pipe(
    map((permissions) => ({
      canRead: !!permissions.ml_model_read,
      canEdit: !!permissions.ml_model_edit,
      canCreate: !!permissions.ml_model_create,
      canDelete: !!permissions.ml_model_delete,
      canImport: !!permissions.ml_model_create,
    }))
  )
}

export const ApplicationEnumerationsPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.permissions).pipe(
    map((permissions) => ({
      canEdit: !!permissions.enum_edit,
      canCreate: !!permissions.enum_create,
      canDelete: !!permissions.enum_delete,
      canImport: !!permissions.enum_edit,
    }))
  )
}

export const ApplicationMediaLibraryPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.permissions).pipe(
    map((permissions) => ({
      canEdit: !!permissions.proj_mediafile_edit,
      canCreate: !!permissions.proj_mediafile_create,
      canDelete: !!permissions.proj_mediafile_delete,
      canImport: !!permissions.proj_mediafile_edit,
    }))
  )
}

export const ApplicationNotificationTemplatesPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.permissions).pipe(
    map((permissions) => ({
      canEdit: !!permissions.notification_templates_edit,
      canCreate: !!permissions.notification_templates_create,
      canDelete: !!permissions.notification_templates_delete,
      canImport: !!permissions.notification_templates_edit,
    }))
  )
}

export const ApplicationDocumentTemplatesPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.permissions).pipe(
    map((permissions) => ({
      canEdit: !!permissions.document_templates_edit,
      canCreate: !!permissions.document_templates_create,
      canDelete: !!permissions.document_templates_delete,
      canImport: !!permissions.document_templates_edit,
    }))
  )
}

export const ApplicationTaskViewsPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.permissions).pipe(
    map((permissions) => ({
      canEdit: !!permissions.task_view_edit,
      canCreate: !!permissions.task_view_create,
      canDelete: !!permissions.task_view_delete,
      canImport: !!permissions.task_view_edit,
    }))
  )
}

export const ApplicationTaskStagesPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.permissions).pipe(
    map((permissions) => ({
      canEdit: !!permissions.stage_edit,
      canCreate: !!permissions.stage_create,
      canDelete: !!permissions.stage_delete,
      canImport: !!permissions.stage_edit,
    }))
  )
}

export const ApplicationTaskAllocationRulesPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.permissions).pipe(
    map((permissions) => ({
      canEdit: !!permissions.allocation_rule_edit,
      canCreate: !!permissions.allocation_rule_create,
      canDelete: !!permissions.allocation_rule_delete,
      canImport: !!permissions.allocation_rule_edit,
    }))
  )
}

export const ApplicationIntegrationSystemsPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.permissions).pipe(
    map((permissions) => ({
      canEdit: !!permissions.data_source_edit,
      canCreate: !!permissions.data_source_create,
      canDelete: !!permissions.data_source_delete,
      canImport: !!permissions.data_source_edit,
    }))
  )
}

export const ApplicationIntegrationWorkflowsPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.workflowAccessRights)
}

export const ApplicationIntegrationProxyConnectionsPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.proxyConnectionsAccessRights)
}

export const ApplicationDependenciesPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.permissions).pipe(
    map((permissions) => ({
      canEdit: !!permissions.dependency_edit,
      canDelete: !!permissions.dependency_delete,
    }))
  )
}

export const ApplicationSettingsPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.applicationAccessRights)
}

export const ApplicationConfigurationparametersPermissionsResolver: ResolveFn<
  DetailedPermissions
> = (): Observable<DetailedPermissions> => {
  const applicationPermissionsStore = inject(ApplicationPermissionsStore)
  // TODO return a signal once Angular supports it
  return toObservable(applicationPermissionsStore.permissions).pipe(
    map((permissions) => ({
      canEdit: !!permissions.config_param_edit,
      canCreate: !!permissions.config_param_create,
      canDelete: !!permissions.config_param_delete,
      canImport: !!permissions.config_param_edit,
    }))
  )
}
